import { combineReducers } from "@reduxjs/toolkit";

import { unitProfilesListingReducer } from "./unitProfilesSlice";

export const unitProfilesReducer = combineReducers({
  unitProfiles: unitProfilesListingReducer,
});
